// import { OutlineFilter as FilterOutline } from '@pixi/filter-outline'

import Player from './entity-player'

class PlayerSystem {
  constructor (game) {
    this.game = game
    this.start()
  }
  start () {
    this.teamMap = new Map()
    this.playerMap = new Map()
    this.forEach = this.playerMap.forEach.bind(this.playerMap)
  }

  teamGet (id) {
    return this.teamMap.get(id)
  }
  teamUpdate (state) {
    this.teamMap.set(state.id, state)
  }
  teamRemove (state) {
    this.teamMap.delete(state.id)
  }

  playerGet (id) {
    return this.playerMap.get(id)
  }
  // We are dead
  //
  // this should go on renderer perhaps?
  playerDead (state) {
    // Kill the sync info
    for (let k in Object.keys(this.game.sync)) {
      clearTimeout(this.game.sync[k])
    }
    // Set the dead filter
    this.game.playing = 3

    this.game.renderer.pixiApp.stage.filters = this.game.renderer.pixi.filters.dead

    this.game.stateUpdate()
  }
  playerRemove (state) {
    let player = this.playerMap.get(state.id)
    player && player.destroy()
    this.playerMap.delete(state.id)
  }
  playerUpdateME (state) {
    // Fetch me? check previous
    this.game.follow = state.follow
    // Check current me on playerMap
    if (!this.playerMap.get(state.id) || this.playerMap.get(state.id).curNode === '') {
      return
    }
    // Died
    if (state.curNode === '') {
      return
    }
    this.game.score = state.score
    this.game.kills = state.kills
    this.game.stateUpdate()
  }
  // Single player update
  playerUpdate (state, isClient) { // Player message/Object update
    setTimeout(() => this.game.calcBoard())

    if (state.id === this.game.ID) {
      this.playerUpdateME(state)
    }

    // If player does not exists we create
    let player = this.playerMap.get(state.id)
    if (state.curNode === '') {
      player && player.destroy()
      this.playerMap.delete(state.id)
      return
    }

    // Node is not null here
    if (!player) {
      player = new Player(this.game, state)
      this.game.renderer.pixi.players.addChild(player.pixiObj)
      this.playerMap.set(state.id, player)
    }

    // Make a method out of this to update Own information
    // This will trigger stuff
    player.set(state, isClient)
  }
  playerRender (delta) {
    const halfWidth = this.game.renderer.width() / 2
    const halfHeight = this.game.renderer.height() / 2

    // NEW: 27-Apr-2018 Real player position indicator TESTING
    // MOVE THIS to player
    this.game.renderer.pixi.playerPos.clear()
    this.playerMap.forEach(p => {
      if (p.state.curNode === '') {
        return
      }
      p.update(delta)

      const ppos = p.pos()
      const node = this.game.nodes.nodeGet(ppos.x, ppos.y)
      if (!node) {
        return
      }

      const g = this.game.renderer.pixi.playerPos

      // g.alpha = 0.7
      g.lineStyle(8, 0x303030)
      g.drawPoly(node.pixiObj.x, node.pixiObj.y, 98, 98, this.game.config.nodeSides)
      g.lineStyle(4, 0xeeeeee)
      g.drawPoly(node.pixiObj.x, node.pixiObj.y, 98, 98, this.game.config.nodeSides)
    })
    /// ////////////////////////
    // Player trackers
    /// //////////
    for (let i = 0; i < 3; i++) { // Top3
      const track = this.game.renderer.pixi.tracking.player.getChildAt(i)
      track.visible = false

      const b = this.game.board[i]
      if (!b || !b.id) continue
      const player = this.playerMap.get(b.id)
      if (!player || !player.pixiObj) continue

      const p = player.pixiObj.toGlobal({ x: 0, y: 0 })
      let sx = p.x - halfWidth
      let sy = p.y - halfHeight
      const m = sy / sx // get the slope // carefull with x=0

      const pad = 20
      if (sx < -halfWidth || sx > halfWidth) {
        track.visible = true
        sx = Math.max(-halfWidth + pad, Math.min(sx, halfWidth - pad))
        // trim sx to screen somehow
        sy = m * sx // slope
      }
      // If sy still higher
      if (sy < -halfHeight || sy > halfHeight) {
        track.visible = true
        sy = Math.max(-halfHeight + pad, Math.min(sy, halfHeight - pad))
        sx = sy / m
      }
      const arrow = track.getChildByName('arrow')
      if (arrow) {
        arrow.rotation = Math.atan2(sy, sx) // since we are at 0
        arrow.tint = player.state.color
      }

      // shift back
      sx += halfWidth
      sy += halfHeight

      track.x = sx
      track.y = sy

      // Paint the circle with proper color
      const g = track.getChildAt(0)
      g.clear()
      g.beginFill(player.state.color)
      g.drawCircle(0, 0, 20)
      g.endFill()
      g.lineStyle(2, 0xffffff)
      g.drawCircle(0, 0, 20)
    }
  }
}

export default PlayerSystem
